
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "../../store/modules/user";
import { IPagination } from "@/types";

import DialogImgLarge from "@/components/ImgLarge/index.vue";
import DialogOrderDetail from "@/components/OrderDetail/index.vue";

import { chargeOffList } from "@/api/stock";
import {
  getOrderDetail,
  getOrderServiceProgressList,
} from "@/api/orderService";

@Component({
  name: "StockCheck",
  components: {
    DialogImgLarge,
    DialogOrderDetail,
  },
})
export default class extends Vue {
  private formSearch: any = {
    order_times: "",
    order_num: "",
  };
  private dataTable: any = [];

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };

  private pageData: any = {};

  private dialogOrderDetailVisible = false;
  private loading = false;

  private selected = "";

  created() {
    this.pageData = JSON.parse(this.$route.query.data as string);
    this.getList();
  }

  private search() {
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      name: "",
      model: "",
      serial: "",
      specification: "",
      type: "",
    };
    this.getList();
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  private getList() {
    this.loading = true;
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.is_charge_off = "1";
    if (this.formSearch.order_times) {
      let data = new Date(this.formSearch.order_times);
      params.order_times = data.getTime() / 1000;
    }
    params.order_num = this.formSearch.order_num;
    params.stock_model_id = this.pageData.model.id;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    chargeOffList(params)
      .then((res) => {
        this.loading = false;
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.dataTable = res.data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
      })
      .catch((error) => {
        this.loading = false;
        this.dataTable = [];
        let msg = error.msg;
      });
  }

  private detail: any = {};
  private orderProgressData: any = {};

  closeDetailHandle() {
    this.dialogOrderDetailVisible = false;
  }

  detailHandle(val: any) {
    this.dialogOrderDetailVisible = true;
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_id: val.id,
    };
    getOrderDetail(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.dialogOrderDetailVisible = true;
          this.detail = data;
          let p: any = {};
          p.user_id = UserModule.getUserId;
          p.company_id = UserModule.getCompanyId;
          p.order_id = val.id;
          p.user_name = UserModule.getUserName;
          p.order_service_id = this.detail.order_service.id;
          getOrderServiceProgressList(p)
            .then((res) => {
              const data = res.data;
              if (data !== null) {
                this.orderProgressData = data;
              } else {
                this.orderProgressData = {};
              }
              if (
                (this.orderProgressData as any).list &&
                (this.orderProgressData as any).list.length > 0
              ) {
                (this.orderProgressData as any).list[0].color =
                  "rgba(185, 235, 247,1)";
              }
              if (
                (this.orderProgressData as any).added_progress &&
                (this.orderProgressData as any).added_progress.length > 0
              ) {
                (this.orderProgressData as any).added_progress[0].color =
                  "rgba(185, 235, 247,1)";
              }
            })
            .catch((err) => {
              let msg = err.msg;
              this.orderProgressData = {};
            });
        }
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private returnHandle() {}

  private confirmHandle() {
    let temp: any = {};
    for (var i = 0; i < this.dataTable.length; i++) {
      if (this.dataTable[i].id === this.selected) {
        temp = this.dataTable[i];
      }
    }
    this.pageData.orderInfo = temp;
    this.$router.push({
      path: "inStock",
      query: {
        stock_name: this.pageData.stock_name,
        model: JSON.stringify(this.pageData.model),
        type: JSON.stringify(this.pageData.type),
        order_info: JSON.stringify(this.pageData.orderInfo),
      },
    });
  }

  private large(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
